const carbonApp = {
  state: {
    areaStore: null,
    dicStatus: null,
    dicQuery: null,
    basicStore: null,
    userAllStore: null,
    isNoticeState: "carbon-neutral-2021031811",
    caches: ["blogList", "myBenefits"]
  },
  actions: {
  },
  mutations: {
    SET_CACHES: (state, caches) => {
      state.caches = caches;
    },
    ADD_CACHE: (state, cache) => {
      state.caches.includes(cache) || state.caches.push(cache);
    },
    DEL_CACHE: (state, cache) => {
      let index = state.caches.indexOf(cache);
      index !== -1 && state.caches.splice(index, 1);
    },
    SET_AREA_STORE: (state, value) => {
      state.areaStore = value
    },
    SET_DIC_STATUS: (state, value) => {
      state.dicStatus = value
    },
    SET_DIC_QUERY: (state, value) => {
      state.dicQuery = value
    },
    SET_BASIC_STORE: (state, value) => {
      state.basicStore = value
    },
    SET_USERAll_STORE: (state, value) => {
      state.userAllStore = value
    },
    SET_NOTICE: (state, value) => {
      console.log(value)
      state.isNoticeState = value
    }
  }
}
export default carbonApp



// WEBPACK FOOTER //
// ./src/store/modules/carbonApp.js